// @flow
import FootNote from './FootNote';

export default FootNote;
